import React, {useEffect, useState} from 'react';
import ApexCharts from 'react-apexcharts';
import {useTranslation} from 'react-i18next';
import {getClientesProspects} from '../../../../pages/requests';
import Spinner from '../../../../components/Spinner';

const ChartComponent = ({leadsProspects, leadsClientes, loading}) => {
    const {t} = useTranslation();
    const [isMobile, setIsMobile] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Last 7 days');
    // const [leadsClientes, setLeadsClientes] = useState({});
    // const [leadsProspects, setLeadsProspects] = useState({});
    // const [loading, setLoading] = useState(true);

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = option => {
        setSelectedOption(option);
        setIsOpen(false);
    };

    const options = {
        colors: ['#1A56DB', '#8aacfc'],

        series: [
            {
                name: t('clientes'),
                color: '#1A56DB',
                data: [
                    {x: t('total'), y: leadsClientes.total},
                    {x: t('ativosVendas'), y: leadsClientes.ativoVendas},
                    {x: t('ativosCrm'), y: leadsClientes.ativosCRM},
                    {x: t('inativosVendas'), y: leadsClientes.inativosVendas},
                    {x: t('inativosCrm'), y: leadsClientes.inativosCRM},
                ],
            },
            {
                name: t('prospects'),
                color: '#8aacfc',
                data: [
                    {x: t('total'), y: leadsProspects.total},
                    {x: t('ativosVendas'), y: leadsProspects.ativoVendas},
                    {x: t('ativosCrm'), y: leadsProspects.ativosCRM},
                    {x: t('inativosVendas'), y: leadsProspects.inativosVendas},
                    {x: t('inativosCrm'), y: leadsProspects.inativosCRM},
                ],
            },
        ],
        chart: {
            type: 'bar',
            height: '320px',
            fontFamily: 'Inter, sans-serif',
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: isMobile ? '50%' : '30%',
                borderRadiusApplication: 'end',
                borderRadius: 8,
            },
        },
        tooltip: {
            shared: true,
            intersect: false,
            style: {
                fontFamily: 'Inter, sans-serif',
            },
        },
        states: {
            hover: {
                filter: {
                    type: 'darken',
                    value: 1,
                },
            },
        },
        stroke: {
            show: true,
            width: 0,
            colors: ['transparent'],
        },
        grid: {
            show: false,
            strokeDashArray: 4,
            padding: {
                left: 2,
                right: 2,
                top: -14,
            },
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: false,
        },
        xaxis: {
            floating: false,
            labels: {
                show: true,
                style: {
                    fontFamily: 'Inter, sans-serif',
                    cssClass: 'text-xs font-normal fill-gray-500 dark:fill-gray-400',
                },
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
        },
        yaxis: {
            show: false,
        },
        fill: {
            opacity: 1,
        },
    };

    useEffect(() => {
        if (document.getElementById('column-chart') && typeof ApexCharts !== 'undefined') {
            const chart = new ApexCharts(document.getElementById('column-chart'), options);
            chart.render();
        }
    }, []);

    // useEffect(() => {
    //     setLoading(false);
    //     var promises = [];
    //     promises.push(
    //         getClientesProspects(lang).then(res => {
    //             if (res.data.success) {
    //                 if (res.data.leads.length > 0) setLeadsClientes(res.data.leads[0]);
    //                 if (res.data.leads.length > 1) setLeadsProspects(res.data.leads[1]);
    //             }
    //         }),
    //     );

    //     Promise.all(promises).finally(() => {
    //         setLoading(false);
    //     });
    // }, []);

    return (
        <div className=" w-full bg-white h-full rounded-[8px] shadow dark:bg-gray-800 p-4 md:p-6">
            {loading ? (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <Spinner />
                    </>
                </div>
            ) : (
                <div>
                    <div className="flex justify-between pb-4 mb-4 border-b border-gray-200 dark:border-gray-700">
                        <div className="flex items-center">
                            <div className="w-12 h-12 rounded-[8px] bg-gray-100 dark:bg-gray-700 flex items-center justify-center me-3">
                                <svg className="w-6 h-6 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 19">
                                    <path d="M14.5 0A3.987 3.987 0 0 0 11 2.1a4.977 4.977 0 0 1 3.9 5.858A3.989 3.989 0 0 0 14.5 0ZM9 13h2a4 4 0 0 1 4 4v2H5v-2a4 4 0 0 1 4-4Z" />
                                    <path d="M5 19h10v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2ZM5 7a5.008 5.008 0 0 1 4-4.9 3.988 3.988 0 1 0-3.9 5.859A4.974 4.974 0 0 1 5 7Zm5 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm5-1h-.424a5.016 5.016 0 0 1-1.942 2.232A6.007 6.007 0 0 1 17 17h2a1 1 0 0 0 1-1v-2a5.006 5.006 0 0 0-5-5ZM5.424 9H5a5.006 5.006 0 0 0-5 5v2a1 1 0 0 0 1 1h2a6.007 6.007 0 0 1 4.366-5.768A5.016 5.016 0 0 1 5.424 9Z" />
                                </svg>
                            </div>
                            <div>
                                <h5 className="leading-none font-bold text-gray-900 dark:text-white pb-1">{t('clienteVsProspects')}</h5>
                                <p className="text-sm font-normal text-gray-500 dark:text-gray-400">{t('statusData')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-row justify-end">
                        <div className="flex  min-w-47.5 px-4 py-1">
                            <div className="flex   justify-center mr-2 items-center  bg-[#1A56DB] w-5 h-5  rounded-full transition-all duration-300 transform group-hover:rotate-12">
                                <span className="w-12 h-12 p-1 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                            </div>
                            <div className="w-full">
                                <p className="font-semibold text-[#1A56DB] ">{t('clientes')}</p>
                            </div>
                        </div>
                        <div className="flex  min-w-47.5 px-4 py-1">
                            <div className="flex   justify-center mr-2 items-center  bg-[#8aacfc] w-5 h-5  rounded-full transition-all duration-300 transform group-hover:rotate-12">
                                <span className="w-12 h-12 p-1 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                            </div>
                            <div className="w-full">
                                <p className="font-semibold text-[#8aacfc] ">{t('prospects')}</p>
                            </div>
                        </div>
                    </div>

                    <div id="column-chart">
                        <ApexCharts options={options} series={options.series} type={options.chart.type} height={options.chart.height} />
                    </div>
                    <div className="grid grid-cols-1 items-center border-gray-200 border-t dark:border-gray-700 justify-between"></div>
                </div>
            )}
        </div>
    );
};

export default ChartComponent;
